// tslint:disable:object-literal-sort-keys
import React from "react";

import * as _ from "lodash";

import { useIntl } from "react-intl";

import { DataSeries, Yaxes } from "./flotmodel";
import { MetaData } from "./MetaData";

import Highcharts, {
  SeriesOptionsType,
  VerticalAlignValue,
  AxisLabelsFormatterCallbackFunction,
  AxisLabelsFormatterContextObject,
} from "highcharts";
import HighchartsReact from "highcharts-react-official";

import dragPanes from "highcharts/modules/drag-panes";
import { SERVER_URI } from "../constants";

dragPanes(Highcharts);

// https://stackoverflow.com/questions/12052671/timezone-on-highcharts
Highcharts.setOptions({
  global: ({
    /**
     * Use moment-timezone.js to return the timezone offset for individual
     * timestamps, used in the X axis labels and the tooltip header.
     */
    getTimezoneOffset: function (timestamp: any) {
      return new Date().getTimezoneOffset();
    },
  } as unknown) as any,
});

// TODO see https://www.highcharts.com/docs/chart-and-series-types/axis-resizer
// TODO see https://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/stock/demo/candlestick-and-volume
// TODO See GUI settings in Apro for missing settings
// DONE Thresholds
// TODO Events
// DONE Bands
// TODO Brush
// DONE Collapsed axis (livedata style)
// TODO Forecast (plotBand on xAxis, consider "zones" like in https://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/series/color-zones-dashstyle-dot/)
// ...
// Events:
// https://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/demo/spline-symbols/
// https://www.highcharts.com/forum/viewtopic.php?t=31633
// TODO min/max issue: https://github.com/highcharts/highcharts/issues/6682
// TODO Autoscale (groups): Highcharts.Series has dataMin/dataMax => can this be used instead of "manually" computing?
// => check https://api.highcharts.com/highcharts/yAxis.min => is it sufficient to set to "null"?

interface TrendGraphProps {
  // nodes: any[];
  // chartData: any[];
  allData: DataSeries[]; // series options (except yaxes?) => TODO allData must be included in metaData.options
  // data: any[];
  metaData: MetaData; // general plot options
  dataSeries: DataSeries[]; // actual data
  widgetStatic?: boolean;
  widgetTitle?: string;
}

function band(yAxis: Yaxes) {
  let low: number | undefined = 0;
  let high: number | undefined = 100;
  if (
    yAxis !== undefined &&
    "band" in yAxis &&
    yAxis.band !== undefined &&
    yAxis.band !== null
  ) {
    low = yAxis.band.low;
    high = yAxis.band.high;
  }
  return {
    low,
    high,
  };
}

function reArrangeYaxis(
  series: DataSeries[],
  metaData: MetaData,
  hasYAxes: boolean
) {
  let yAxisColumns: number[][] = [];

  // const yAxes: Highcharts.YAxisOptions[] = series /*.filter(node => node.tagId !== -1)*/
  // .map((node: any, index: number) => {
  for (let seriesIndex = 0; seriesIndex < series.length; seriesIndex++) {
    // const s = series[seriesIndex];
    // const yaxis = series[seriesIndex].yaxis;
    // console.log("seriesIndex", seriesIndex, series[seriesIndex]);
    if (series[seriesIndex].tagId === -1) {
      continue;
    }

    let low: number | undefined = 0;
    let high: number | undefined = 100;
    let visible = true;
    if (hasYAxes) {
      // const seriesIndexY = series[seriesIndex].yaxis || 0;
      const yAxis = metaData.options.yaxes[seriesIndex]; // TODO series[seriesIndex].yaxis instead of seriesIndex?
      if ("show" in yAxis) {
        // TODO alwaysShowThresholds is a workaround because thresholds are not shown if the axis is not shown!
        visible = !!yAxis.show || !!yAxis.alwaysShowThresholds;
      }
      if ("band" in yAxis && yAxis.band !== undefined && yAxis.band !== null) {
        low = yAxis.band.low;
        high = yAxis.band.high;
      }

      if (!!visible) {
        let shiftTo: number = 0;
        let pos: number = 0;
        let shiftAble = false;
        // console.log("seriesIndex", seriesIndex, "low", low, "high", high);
        // go through the already checked columns and see if the y-axis fits into another column
        for (
          let columnIndex = yAxisColumns.length - 1;
          columnIndex >= 0;
          columnIndex--
        ) {
          // console.log("columnIndex", columnIndex);
          const yAxisColumn = yAxisColumns[columnIndex];
          // shiftAble = false;
          // check if yaxis fits in the column between the top of the plot and the highest y-axis currently being in column
          const firstSeriesIndex = yAxisColumn[0];
          // const firstSeriesIndexY = series[firstSeriesIndex].yaxis || 0;
          const firstSeriesBand = band(
            metaData.options.yaxes[firstSeriesIndex]
          );
          // console.log("firstSeriesBand", firstSeriesBand);
          if (fitsColumn(high, low, 100, firstSeriesBand.high)) {
            shiftTo = columnIndex;
            shiftAble = true;
            pos = 0;
            // console.log("fit", shiftTo, shiftAble, pos);
          }

          // check if yaxis fits between two y-axis currently being in the column
          for (let i = 0; i < yAxisColumn.length - 1; i++) {
            const upperSeriesIndex = yAxisColumn[i];
            // const upperSeriesIndexY = series[upperSeriesIndex].yaxis || 0;
            const lowerSeriesIndex = yAxisColumn[i + 1];
            // const lowerSeriesIndexY = series[lowerSeriesIndex].yaxis || 0;
            const upperSeriesBand = band(
              metaData.options.yaxes[upperSeriesIndex]
            );
            const lowerSeriesBand = band(
              metaData.options.yaxes[lowerSeriesIndex]
            );
            // console.log("upperSeriesBand", upperSeriesBand);
            // console.log("lowerSeriesBand", lowerSeriesBand);
            if (
              fitsColumn(high, low, upperSeriesBand.low, lowerSeriesBand.high)
            ) {
              shiftTo = columnIndex;
              shiftAble = true;
              pos = i + 1;
              // console.log("fit", shiftTo, shiftAble, pos);
            }
          }

          // check if yaxis fits in the column between the bottom of the plot and the lowest y-axis currently being in the column
          const lastSeriesIndex = yAxisColumn[yAxisColumn.length - 1];
          // const lastSeriesIndexY = series[lastSeriesIndex].yaxis || 0;
          const lastSeriesBand = band(metaData.options.yaxes[lastSeriesIndex]);
          // console.log("lastSeriesBand", lastSeriesBand);
          if (fitsColumn(high, low, lastSeriesBand.low, 0)) {
            // console.log("fit");
            shiftTo = columnIndex;
            shiftAble = true;
            pos = yAxisColumn.length;
            // console.log("fit", shiftTo, shiftAble, pos);
          }
          if (!shiftAble) {
            break;
          }
        }

        if (shiftAble === true) {
          // if the yaxis fits into the column, add it to the column
          yAxisColumns[shiftTo].splice(pos, 0, seriesIndex);
          // console.log("inserting at column", shiftTo, "position", pos);
          // TODO yaxis.options.shiftedTo = shiftTo;
        } else {
          // if not, create a new column and put the yaxis to this new column
          // console.log("creating new column");
          // console.log("pushing series ", seriesIndex);
          yAxisColumns.push([seriesIndex]);
        }
      }
    }
  }

  return yAxisColumns;
}

function fitsColumn(
  highPosition: number,
  lowPosition: number,
  top: number,
  bottom: number
) {
  // return highPosition >= top && lowPosition <= bottom;
  // return top >= highPosition && bottom <= lowPosition;
  return highPosition <= top && lowPosition >= bottom;
}

function calculateOffset(yAxisColumns: number[][], index: number) {
  for (let columnIndex = 0; columnIndex < yAxisColumns.length; columnIndex++) {
    const yAxisColumn = yAxisColumns[columnIndex];
    if (yAxisColumn.includes(index)) {
      return /*yAxisColumns.length - 1 -*/ columnIndex;
    }
  }
  return 0;
}

function TrendGraphHighcharts(props: TrendGraphProps) {
  // startDate={data.durationSelect && data.durationSelect.startDate || '2010-01-01T00:00:00.00Z'} endDate={data.durationSelect && data.durationSelect.endDate || '2020-01-01T00:00:00.00Z'}
  const {
    /*nodes, chartData,*/ allData,
    metaData /*, data*/,
    dataSeries,
  } = props;
  const hasYAxes = !_.isNil(
    metaData && metaData.options && metaData.options.yaxes
  );
  // console.log("metaData", metaData);

  const intl = useIntl();

  const yAxisColumns = reArrangeYaxis(allData, metaData, hasYAxes);
  // console.log("reArrangeYaxis", yAxisColumns);
  // TODO Set offset of axes (offset: 1,)
  const preprocessedYAxes: Highcharts.YAxisOptions[] = allData /*.filter(node => node.tagId !== -1)*/
    .map((node: any, index: number) => {
      let color: string | undefined;
      let drawGrid: boolean | undefined = false;
      let min: number | undefined = 0;
      let max: number | undefined;
      let plotBands;
      let plotLines;
      let low: number | undefined = 0;
      let high: number | undefined = 100;
      let ticks: number | undefined;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      let tickInterval = undefined;
      let unit: string | undefined = "";
      let visible = true;
      let offset: number = 0;
      let gridLineColor: string | undefined;
      if (hasYAxes) {
        const yAxis = metaData.options.yaxes[index]; // TODO node.yaxis instead of seriesIndex?
        if (
          "color" in node &&
          node.color !== undefined &&
          node.color !== null
        ) {
          color = node.color;
        } else if (
          "color" in yAxis &&
          yAxis.color !== undefined &&
          yAxis.color !== null
        ) {
          color = yAxis.color;
        }
        if ("drawGrid" in yAxis) {
          drawGrid = !!yAxis.drawGrid;
        }
        if ("gridColor" in yAxis) {
          gridLineColor = yAxis.gridColor;
        }
        if ("min" in yAxis && yAxis.min !== undefined) {
          if (yAxis.min !== null) {
            min = yAxis.min;
          } else {
            // TODO Autoscale group?!
            const series = dataSeries?.find((ser) => ser.tagId === node.tagId);
            if (series) {
              let localMin = _.min(series.data.map((x) => parseFloat(x[1])));
              if (localMin) {
                min = Math.floor(localMin); // TODO Highcharts.correctFloat?
              }
            }
            if (min !== undefined) {
              min = Highcharts.correctFloat(parseFloat(min.toFixed(1))); // TODO check this again
            }
          }
        }
        if ("max" in yAxis && yAxis.max !== undefined) {
          if (yAxis.max !== null) {
            max = yAxis.max;
          } else {
            // TODO Autoscale group?!
            const series = dataSeries?.find((ser) => ser.tagId === node.tagId);
            if (series) {
              let localMax = _.max(series.data.map((x) => parseFloat(x[1])));
              if (localMax) {
                max = Math.ceil(localMax); // TODO Highcharts.correctFloat?
              }
            }
          }
          if (max !== undefined) {
            max = Highcharts.correctFloat(parseFloat(max.toFixed(1))); // TODO check this again
          }
        }
        if ("show" in yAxis) {
          // TODO alwaysShowThresholds is a workaround because thresholds are not shown if the axis is not shown!
          visible = !!yAxis.show || !!yAxis.alwaysShowThresholds;
        }
        if (
          "ticks" in yAxis &&
          yAxis.ticks !== undefined &&
          yAxis.ticks !== null
        ) {
          ticks = yAxis.ticks + 1;
        }
        if ("unit" in yAxis) {
          unit = yAxis.unit;
        }
        offset = calculateOffset(yAxisColumns, index);
        if (
          "band" in yAxis &&
          yAxis.band !== undefined &&
          yAxis.band !== null
        ) {
          low = yAxis.band.low;
          high = yAxis.band.high;
        }
        if (_.isNumber(ticks) && _.isNumber(min) && _.isNumber(max)) {
          tickInterval = (max - min) / (ticks - 1);
        }

        // console.log("thresholds", index, yAxis.thresholds);
        if (
          "thresholds" in yAxis &&
          yAxis.thresholds !== undefined &&
          yAxis.thresholds !== null
        ) {
          plotBands = yAxis.thresholds
            .filter(
              (threshold: any) => !!threshold.visible && !!threshold.paintFill
            )
            .map((threshold: any) => ({
              color: threshold.fillColor,
              from: Number(
                threshold.fillTo === 0
                  ? threshold.fillBase
                  : threshold.fillTo === 1
                  ? min
                  : threshold.value
              ),
              to: Number(
                threshold.fillTo === 0 || threshold.fillTo === 1
                  ? threshold.value
                  : max
              ),
              zIndex: -2, // ensure label is visible if FILL_TO_MAX_SCALE and does not overlap plot lines
              label: {
                text: !!threshold.paintLine
                  ? ""
                  : !!threshold.showName
                  ? threshold.name
                  : `${threshold.value}${yAxis.unit}`,
                verticalAlign: "bottom" as VerticalAlignValue,
                y: -2,
                style: {
                  color: threshold.labelColor,
                  textShadow:
                    "-1px 0 white, 0 1px white, 1px 0 white, 0 -1px white",
                },
              },
            }));
          plotLines = yAxis.thresholds
            .filter(
              (threshold: any) => !!threshold.visible && !!threshold.paintLine
            )
            .map((threshold: any) => ({
              color: threshold.lineColor,
              value: Number(threshold.value),
              width: Number(threshold.lineWeight),
              zIndex: -1,
              label: {
                text: !!threshold.showName
                  ? threshold.name
                  : `${threshold.value}${yAxis.unit}`,
                verticalAlign: "bottom" as VerticalAlignValue,
                y: -2,
                style: {
                  color: threshold.labelColor,
                  textShadow:
                    "-1px 0 white, 0 1px white, 1px 0 white, 0 -1px white",
                },
              },
            }));
        }
      }
      // TODO grid color {metaData.options.grid.color}
      return {
        title: {
          text: ``, // `${node.tagId === -1 ? "" : node.label || node.tagId}`,
          style: {
            color: color,
          },
        },
        visible: visible,
        // minPadding: 0,
        // maxPadding: 0,
        max: max,
        min: min,
        height: `${(high || 100) - (low || 0)}%`,
        top: `${100 - (high || 100)}%`,
        // resize: {
        //   enabled: true,
        // },
        labels: {
          format: unit && unit.trim() !== "" ? `{value} ${unit}` : `{value}`,
          style: {
            color: color,
          },
        },
        unit: unit, // TODO unit is technically not part of YAxisOptions, but needed if "combined" axis is used
        lineColor: color, // TODO axisLine={node.tagId !== -1} => lineWidth...
        tickColor: color,
        tickAmount: ticks,
        // tickInterval: tickInterval,
        plotBands: plotBands,
        plotLines: plotLines,
        // offset: 0,
        offset: offset * 60,
        gridLineColor: gridLineColor,
        gridLineWidth: drawGrid ? 1 : 0,
        tickPositioner: function () {
          const positions = [];
          const increment = (max! - min!) / (ticks! - 1);

          if (min !== null && max !== null) {
            positions.push(min!);
            for (let i = 1; i < ticks! - 1; i++) {
              const pos = Highcharts.correctFloat(
                parseFloat((min! + increment * i).toFixed(1))
              ); // TODO check this again
              positions.push(pos);
              // positions.push(Highcharts.correctFloat(min! + increment * i, 3));
            }
            positions.push(max!);
          }
          return positions;
        },
      };
    });
  let yAxes = preprocessedYAxes;

  const combined =
    hasYAxes && metaData.options.yaxis && !!metaData.options.yaxis.combined;
  const showCombinedMiddleTick =
    hasYAxes &&
    metaData.options.yaxis &&
    !!metaData.options.yaxis.showCombinedMiddleTick;
  if (!!combined) {
    const inter = yAxes.map((yAxis) => {
      const color = yAxis.labels?.style?.color;
      const min = yAxis.min;
      const max = yAxis.max;
      // TODO consider yAxis.labels.format and use replace('{value}', min/max/middle) to get rid of "artificial" unit value
      const unit = (yAxis as any)?.unit;
      const visible = yAxis.visible;
      const unitSpaced = unit && unit.trim() !== "" ? ` ${unit}` : "";
      return {
        first: `<span style="color: ${color}">${Highcharts.correctFloat(
          parseFloat((min || 0).toFixed(1))
        )}${unitSpaced}</span>`,
        middle: `<span style="color: ${color}">${Highcharts.correctFloat(
          parseFloat(((min || 0) + ((max || 0) - (min || 0)) / 2).toFixed(1))
        )}${unitSpaced}</span>`,
        last: `<span style="color: ${color}">${Highcharts.correctFloat(
          parseFloat((max || 0).toFixed(1))
        )}${unitSpaced}</span>`,
        visible,
      };
    });

    // const labelHeight: number = 14.375;
    const createCombinedAxis = (inputYAxes: any[], opposite: boolean) => {
      const inputYAxes2 = inputYAxes
        .filter((yAxis, index) => allData[index].tagId !== -1)
        .filter((yAxis, index) => (index % 2 === 0) !== opposite);
      return {
        labels: {
          //     format: '{value}°C',
          //     // style: {
          //     //     color: Highcharts.getOptions().colors[1]
          //     // }
          // useHTML: true,
          // y: (!!myThis.isLast) ? 0 : undefined, //(labelHeight * inputYAxes2.length / 2),
          formatter: (((myThis: AxisLabelsFormatterContextObject) => {
            if (!!myThis.isFirst) {
              return inputYAxes2.map((yAxis) => yAxis.first).join("<br />");
              // return "min";
            } else if (!!myThis.isLast) {
              return inputYAxes2.map((yAxis) => yAxis.last).join("<br />");
              // const result = allData.filter(node => node.tagId !== -1).map((node: any, index: number) => {
              //  if (hasYAxes) {
              //     const yAxis = metaData.options.yaxes[index]; // TODO node.yaxis instead of seriesIndex?
              // });
              // return "max";
            } else {
              return inputYAxes2.map((yAxis) => yAxis.middle).join("<br />");
              // return myThis.value;
            }
          }) as unknown) as AxisLabelsFormatterCallbackFunction,
        },
        title: {
          text: "",
          // style: {
          //     color: Highcharts.getOptions().colors[1]
          // }
        },
        tickAmount: showCombinedMiddleTick ? 3 : 2,
        opposite: opposite,
        visible: true,
      };
    };

    yAxes = [
      createCombinedAxis(inter, false),
      createCombinedAxis(inter, true),
      ...yAxes.map((yAxis) => ({ ...yAxis, visible: false })),
    ];
  }

  const series = allData
    .filter((node) => node.tagId !== -1)
    .map((node: any, index: number) => {
      const series = dataSeries?.find((ser) => ser.tagId === node.tagId);
      const name = `${node.tagId === -1 ? "" : node.label || node.tagId}`;
      let color;
      let type;
      let unit;
      let visible = true;
      let lineWidth;
      if (hasYAxes) {
        const yAxis = metaData.options.yaxes[index];
        if (
          "color" in node &&
          node.color !== undefined &&
          node.color !== null
        ) {
          color = node.color;
        } else if (
          "color" in yAxis &&
          yAxis.color !== undefined &&
          yAxis.color !== null
        ) {
          color = yAxis.color;
        }
        if ("unit" in yAxis) {
          unit = yAxis.unit;
        }
      }

      if ("bars" in node && node.bars !== undefined && node.bars !== null) {
        // Bar
        type = "column";
        // fill={node.color}
        if ("show" in node.bars) {
          visible = !!node.bars.show;
        }
      } else if (
        "lines" in node &&
        node.lines !== undefined &&
        node.lines !== null
      ) {
        if (!!node.lines.fill) {
          // Area
          type = "area";
          // fill={node.color}
        } else {
          // Line
          type = "line";
          // stroke={node.color}
          // dot={false}
        }
        if ("show" in node.lines) {
          visible = !!node.lines.show;
        }
        // if ("lineWidth" in node.lines && node.lines.lineWidth !== undefined && node.lines.lineWidth !== null) {
        lineWidth = node.lines.lineWidth;
        // }
      } else {
        // TODO events
        // mark = "text";
      }

      // TODO yAxis: `${node.tagId}` or node.yaxis
      return {
        name: `${name} (${unit})`, // name,
        type: type,
        color: color,
        data: series
          ? _.sortBy(
              series.data.map((x) => [parseInt(x[0], 10), parseFloat(x[1])]), // TODO Highcharts.correctFloat?
              [(o) => o[0]]
            )
          : undefined,
        yAxis: combined ? index + 2 : index,
        // yAxis: combined ? (index % 2) : index,
        lineWidth: lineWidth,
        visible: visible,
        tooltip: {
          valueSuffix: unit,
        },
      } as SeriesOptionsType;
    });
  const eventSeries = dataSeries?.find((ser) => ser.tagId === -1);
  if (eventSeries) {
    if (eventSeries.data) {
      /*const data =*/ eventSeries.data.map((value, index) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const duration = value[1];
        const tooltip = value[2];
        // TODO Fix y position
        // TODO Add duration
        const y = /*20 * */ index;
        return {
          x: value[0],
          y: y,
          text: tooltip, // Note: text is not standardized and only used for the tooltip
          marker: {
            symbol: `url(${SERVER_URI}/${value[7]})`, // TODO Set correct url
          },
        };
      });

      // TODO enable events!
      // It was deactivated because long events lead to huge charts with mostly white space => set "viewport" of x-axis
      // series.push({
      //   type: "scatter", // TODO Which type? 'scatter' or 'flags' from highstock?
      //   name: "Events",
      //   lineWidth: 0,
      //   // min: 0, // TODO remove
      //   // max: eventSeries.data.length, // TODO remove
      //   marker: {
      //     enabled: true // show always, not only on hover
      //   },
      //   tooltip: {
      //     pointFormat: "{point.text}"
      //   },
      //   data: data
      //   // yAxis: index, TODO
      // });
    }
  }

  if (!!combined) {
    //   const seriesForCombined = series.map((s, index) => ({...s, yAxis: index % 2, visible: false}) as SeriesOptionsType);
    //   series.push(...seriesForCombined);
    // TODO this leads to an additional point in the series
    const data = [(series.find((s: any) => s.data.length > 0) as any)?.data[0]];
    series.push({
      data: data,
      yAxis: 0,
      visible: true,
      showInLegend: false,
      showInNavigator: false,
      // showEmpty: true,
    } as SeriesOptionsType);
    series.push({
      data: data,
      yAxis: 1,
      visible: true,
      showInLegend: false,
      showInNavigator: false,
      // showEmpty: true,
    } as SeriesOptionsType);
  }

  // TODO check if zoom/pan leads to scrolling issues on mobile
  // => disable only on mobile
  const options: Highcharts.Options = {
    title: {
      text: "",
    },
    chart: {
      marginTop: !!combined ? (dataSeries?.length || 0) * 4 : undefined,
      // zoomType: "x",
      // panning: {
      //   enabled: true,
      //   type: "x",
      // },
      // panKey: "shift",

      // events: {
      //   selection: (event: any) => {
      //     console.log("Chart Selection: ", event);
      //     const start = Math.floor(event.xAxis[0].min);
      //     const end = Math.ceil(event.xAxis[0].max);
      //     // const chart = this; // or event.target; // or event.xAxis[0].axis.chart;
      //     // TODO return false to prevent zoom?
      //     // return undefined;
      //     return false;
      //   }
      // },
      backgroundColor: "transparent", // TODO from options
    },
    plotOptions: {
      line: {
        marker: {
          enabled: false,
        },
      },
    },
    xAxis: {
      type: "datetime",
      crosshair: true,
      // tickAmount: metaData.options.xaxis.ticks,
      gridLineWidth: 1,
    },
    yAxis: yAxes,
    tooltip: {
      shared: true,
      formatter: function (tooltip) {
        let hoveredPoints = this.points || [];
        let chart = tooltip.chart;
        let xVal = this.x;
        let tooltipStr =
          "<b>" + intl.formatDate(xVal) + " " + intl.formatTime(xVal) + "</b>";

        // Go through each series and add its value to the tooltip string
        chart.series
          .filter((series: any) => series.index <= preprocessedYAxes.length - 2)
          .forEach((series: any) => {
            let hoverPoint = Highcharts.find(hoveredPoints, function (p: any) {
              return p.series === series;
            });
            let yVal: any = hoverPoint && hoverPoint.y;
            let numPoints = series.points.length;
            let i = numPoints;
            let pointLess;
            let pointMore;
            let interpolated = yVal === undefined;

            if (interpolated) {
              // We need to interpolate. Find a point with smaller and one with greater X value.
              while (i--) {
                if (!series.points[i].isNull && series.points[i].x < xVal) {
                  pointLess = series.points[i];
                  break;
                }
              }
              for (i = 0; i < numPoints; ++i) {
                if (!series.points[i].isNull && series.points[i].x > xVal) {
                  pointMore = series.points[i];
                  break;
                }
              }

              if (!pointLess || !pointMore) {
                // For ends, don't interpolate
                yVal = "-";
              } else {
                yVal =
                  pointLess.y +
                  ((pointMore.y - pointLess.y) / (pointMore.x - pointLess.x)) *
                    (xVal - pointLess.x);
                // yVal = Highcharts.correctFloat(yVal, 3);
              }
            }
            if (_.isFinite(yVal)) {
              yVal = Highcharts.correctFloat(parseFloat(yVal.toFixed(1))); // TODO check this again
            }

            tooltipStr +=
              "<br/>" + // + (interpolated ? '<span style="color: #999">' : '')
              `<span style="color: ${hoverPoint?.color}">` +
              series.name +
              ": " +
              yVal +
              `</span>`;
          });

        return tooltipStr;
      },
    },
    series: series,
    credits: {
      enabled: false,
    },
  };
  // console.log("Highcharts Options", options);

  return (
    <HighchartsReact
      containerProps={{ style: { height: "100%" /*, width: "100%"*/ } }}
      highcharts={Highcharts}
      options={options}
    />
  );
}

export default TrendGraphHighcharts;
